var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.item.value)?_c('span',[_vm._v(_vm._s(_vm.item.value))]):(!_vm.item.value)?_c('span',[_c('pre',[_vm._v("null")])]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }